import inputTypeStore from '@/components/input-file/input-type';
import { runInAction } from 'mobx';
import { observer } from 'mobx-react-lite';
import InputFile from '../input-file/InputFile';
import { ACCEPT_FILE_TYPE, ACCEPT_IMG_TYPE } from '../input-file/shared';
import { HelpOther } from '@/common/helper';
import userStore from '@/store/user';

const MAX_FILE_SIZE = 200;

function UploadFile({ children, disable }) {
  if (disable || !userStore.isUser) {
    return children;
  }

  const ACCEPT_TYPES = ACCEPT_FILE_TYPE.concat(ACCEPT_IMG_TYPE);

  return (
    <InputFile
      multiple
      accept={ACCEPT_TYPES.join(',')}
      onChange={event => {
        const files = event.target.files;
        if (!files || !files.length) return;
        for (let i = 0; i < files.length; i++) {
          const file = files[i];
          const fileType = file.name.slice(file.name.lastIndexOf('.'));
          if (file.size > 1024 * 1024 * MAX_FILE_SIZE) {
            HelpOther.toast(`文件大小不能超过 ${MAX_FILE_SIZE}MB`, 'info');
            return false;
          }
          if (!ACCEPT_TYPES.includes(fileType.toLocaleLowerCase())) {
            HelpOther.toast(`不支持的文件类型`, 'info');
            return;
          }
        }
        try {
          runInAction(() => {
            inputTypeStore.updateTempData('tempFile', files);
          });
        } finally {
        }
      }}
    >
      {children}
    </InputFile>
  );
}

export default observer(UploadFile);
